import { LOADER, LOGIN } from "../definitions";

const initialStates = {
  login: null,
  error: "",
  isLoader: false,
};

const loginReducer = (state = initialStates, action) => {
  switch (action.type) {
    case LOGIN.START_FETCH: {
      return {
        ...state,
        login: null,
      };
    }
    case LOGIN.FINISH_FETCH: {
      return {
        ...state,
        login: action.payload,
        isLoader: false,
        error: "",
      };
    }
    case LOGIN.FAIL_FETCH: {
      return {
        error: action.payload,
        isLoader: false,
      };
    }
    case LOADER.START_LOADER: {
      return {
        ...state,
        isLoader: action.payload,
      };
    }
    case LOADER.END_LOADER: {
      return {
        ...state,
        isLoader: action.payload,
      };
    }
    default:
      return state;
  }
};

export { loginReducer };
